import { n as c, t as J } from "./events-BhpKDDpP.js";
import { GraphQLClient as ee } from "graphql-request";
import p from "js-cookie";
import ne from "keycloak-js";
import R from "ky";
import { QueryClient as ie, isServer as ae } from "@tanstack/react-query";
import V from "deepmerge";
import { create as B } from "zustand";
import te from "dayjs";
var qn = 84772729, Xn = "dataLayer", de = "trackAnalytics", Hn = "GTM-K89MWRP", Qn = "GTM-5LNKZGHD", Zn = "RozSDK", Jn = "https://t.me/Roz_Auth_bot", ei = "https://max.ru/obshestvo_znanie_bot", ni = "ysc1_ivDUA2B49VsJ107UtvHuDEA9Ix9VfwYWu3DZDtZ51574bf25", ii = "XXX__super-secret-omit-maintenance-mode___XXX", f = typeof process < "u" && !!process.env, re = f && process.env.NEXT_PUBLIC_WERF_ENV ? process.env.NEXT_PUBLIC_WERF_ENV === "production" ? "https://znanierussia.ru" : `https://${process.env.NEXT_PUBLIC_WERF_ENV}.znanierussia.ru` : !1, ai = f && process.env.NEXT_PUBLIC_WERF_ENV === "production" || !0, le = re || "https://znanierussia.ru", oe = f && process.env.NEXT_PUBLIC_API_HOST || "https://api.znanierussia.ru", se = f && process.env.NEXT_PUBLIC_API_URL || "https://api.znanierussia.ru/graphql", me = f && process.env.NEXT_PUBLIC_KEYCLOAK_URL || "https://auth.znanierussia.ru", ue = f && process.env.NEXT_PUBLIC_KEYCLOAK_REALM || "ROZ", ke = f && process.env.NEXT_PUBLIC_KEYCLOAK_CLIENT_ID || "roz-frontend", ti = "policy_accepted", g = {
  postLogout: "post_logout",
  authorizeInFlight: "authorize_in_flight"
}, di = 15e3, M = { hasCallback: "1" }, ri = "Обязательное поле", li = "Обязательное поле. Пожалуйста, выберите вариант из списка", oi = "Должно содержать только кириллицу, тире и пробел и начинаться с большой буквы", si = "Не должно содержать только пробелы", mi = "Неверный формат email", ui = {
  home: "/",
  profile: "/profile/main",
  profileLector: "/profile/lector",
  profileApplector: "/profile/applector",
  search: "/search",
  events: "/events",
  projects: "/projects",
  speakers: "/speakers",
  library: "/library",
  cinema: "/cinema",
  podcasts: "/podcasts",
  about: "/about",
  management: "/management",
  news: "/news",
  oVajnom: "/razgovory-o-vazhnom",
  press: "/press",
  becomeMember: "/become-member",
  becomePartner: "/become-partner"
}, ce = /^(?![\s'’-])(?!.*[\s'’-]$)(?!.*[А-ЯЁ]{2})(?!.*['’`\s-]{2})(?=(?:[^'’`]*['’`]){0,1}[^'’`]*$)(?=(?:[^\s]*\s){0,1}[^\s]*$)(?=(?:[^-]*-){0,3}[^-]*$)^[А-ЯЁ](?:(?:[а-яёА-ЯЁ]*|-[А-ЯЁ]?[а-яёА-ЯЁ]*|['’`\s][А-ЯЁ]?[а-яёА-ЯЁ]*)(?:\s|$)?)+$/, ve = /[ієїґ']+/i, ki = /^(tel|mailto):/gm, ci = /^http(s)?:\/{2}(www.)?[\w-]+\.[\w]+/gim, vi = {
  sdkRoot: "roz-sdk-root",
  beforeTabbarMenu: "roz-sdk-tabbar-before-menu",
  afterTabbarMenu: "roz-sdk-tabbar-after-menu",
  headerAfterLogo: "roz-header_after-logo"
}, pi = /* @__PURE__ */ (function(e) {
  return e.Article = "ARTICLE", e.Material = "MATERIAL", e.Podcast = "PODCAST", e.Video = "VIDEO", e;
})({}), b = /* @__PURE__ */ (function(e) {
  return e.A_0 = "A_0", e.A_1 = "A_1", e.A_2 = "A_2", e.A_3 = "A_3", e.A_4 = "A_4", e.A_5 = "A_5", e;
})({}), pe = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "AddressFields"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "AddressType"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "area"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "areaFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "areaKladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "areaType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "areaTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "areaWithType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "block"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "blockType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "blockTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "capitalMarker"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "city"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityArea"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityDistrict"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityDistrictFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityDistrictKladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityDistrictType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityDistrictTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityDistrictWithType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityKladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityWithType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "country"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "countryIsoCode"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "entrance"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "federalDistrict"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "fiasCode"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "fiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "fiasLevel"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "flat"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "flatArea"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "flatCadnum"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "flatFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "flatType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "flatTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "floor"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "geoLat"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "geoLon"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "geonameId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "historyValues"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "house"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "houseCadnum"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "houseFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "houseKladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "houseType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "houseTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "kladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "postalBox"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "postalCode"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "region"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "regionFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "regionIsoCode"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "regionKladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "regionType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "regionTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "regionWithType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "settlement"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "settlementFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "settlementKladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "settlementType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "settlementTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "settlementWithType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "street"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "streetFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "streetKladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "streetType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "streetTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "streetWithType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "timezone"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "unparsedParts"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "value"
          }
        }
      ]
    }
  }]
}, ye = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "CheckEmailCode"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "email"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "code"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "emailCodeCheck"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "email"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "email"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "code"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "code"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "success"
            }
          }]
        }
      }]
    }
  }]
}, Ne = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "Login"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "username"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "token"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "tokenAuth"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "username"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "username"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "password"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "token"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "payload"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "token"
            }
          }]
        }
      }]
    }
  }]
}, Fe = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "Logout"
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "deleteTokenCookie"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "deleted"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "deleteRefreshTokenCookie"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "deleted"
            }
          }]
        }
      }]
    }
  }]
}, he = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "Registration"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "user"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "UserInput"
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "registerUser"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "user"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "user"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
}, ge = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "SendAuthEmail"
    },
    variableDefinitions: [
      {
        kind: "VariableDefinition",
        variable: {
          kind: "Variable",
          name: {
            kind: "Name",
            value: "username"
          }
        },
        type: {
          kind: "NonNullType",
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "String"
            }
          }
        }
      },
      {
        kind: "VariableDefinition",
        variable: {
          kind: "Variable",
          name: {
            kind: "Name",
            value: "refererUrl"
          }
        },
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      },
      {
        kind: "VariableDefinition",
        variable: {
          kind: "Variable",
          name: {
            kind: "Name",
            value: "ymClientId"
          }
        },
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    ],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "sendEmailCode"
        },
        arguments: [
          {
            kind: "Argument",
            name: {
              kind: "Name",
              value: "email"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "username"
              }
            }
          },
          {
            kind: "Argument",
            name: {
              kind: "Name",
              value: "refererUrl"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "refererUrl"
              }
            }
          },
          {
            kind: "Argument",
            name: {
              kind: "Name",
              value: "ymClientId"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "ymClientId"
              }
            }
          }
        ],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "success"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "userExists"
            }
          }]
        }
      }]
    }
  }]
}, fe = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "SmsAuthWithToken"
    },
    variableDefinitions: [
      {
        kind: "VariableDefinition",
        variable: {
          kind: "Variable",
          name: {
            kind: "Name",
            value: "phone"
          }
        },
        type: {
          kind: "NonNullType",
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "String"
            }
          }
        }
      },
      {
        kind: "VariableDefinition",
        variable: {
          kind: "Variable",
          name: {
            kind: "Name",
            value: "token"
          }
        },
        type: {
          kind: "NonNullType",
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "String"
            }
          }
        }
      },
      {
        kind: "VariableDefinition",
        variable: {
          kind: "Variable",
          name: {
            kind: "Name",
            value: "uuid"
          }
        },
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "UUID"
          }
        }
      }
    ],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "createSmsAuthorizeWithToken"
        },
        arguments: [
          {
            kind: "Argument",
            name: {
              kind: "Name",
              value: "phone"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "phone"
              }
            }
          },
          {
            kind: "Argument",
            name: {
              kind: "Name",
              value: "token"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "token"
              }
            }
          },
          {
            kind: "Argument",
            name: {
              kind: "Name",
              value: "uuid"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "uuid"
              }
            }
          }
        ],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "userExists"
            }
          }]
        }
      }]
    }
  }]
}, Te = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "TokenAuthVk"
    },
    variableDefinitions: [
      {
        kind: "VariableDefinition",
        variable: {
          kind: "Variable",
          name: {
            kind: "Name",
            value: "code"
          }
        },
        type: {
          kind: "NonNullType",
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "String"
            }
          }
        }
      },
      {
        kind: "VariableDefinition",
        variable: {
          kind: "Variable",
          name: {
            kind: "Name",
            value: "codeVerifier"
          }
        },
        type: {
          kind: "NonNullType",
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "String"
            }
          }
        }
      },
      {
        kind: "VariableDefinition",
        variable: {
          kind: "Variable",
          name: {
            kind: "Name",
            value: "deviceId"
          }
        },
        type: {
          kind: "NonNullType",
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "String"
            }
          }
        }
      }
    ],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "tokenAuthVkId"
        },
        arguments: [
          {
            kind: "Argument",
            name: {
              kind: "Name",
              value: "code"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "code"
              }
            }
          },
          {
            kind: "Argument",
            name: {
              kind: "Name",
              value: "codeVerifier"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "codeVerifier"
              }
            }
          },
          {
            kind: "Argument",
            name: {
              kind: "Name",
              value: "deviceId"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "deviceId"
              }
            }
          }
        ],
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "payload"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "refreshExpiresIn"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "token"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "refreshToken"
              }
            }
          ]
        }
      }]
    }
  }]
}, Ie = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "GetAddress"
    },
    variableDefinitions: [
      {
        kind: "VariableDefinition",
        variable: {
          kind: "Variable",
          name: {
            kind: "Name",
            value: "term"
          }
        },
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      },
      {
        kind: "VariableDefinition",
        variable: {
          kind: "Variable",
          name: {
            kind: "Name",
            value: "from"
          }
        },
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      },
      {
        kind: "VariableDefinition",
        variable: {
          kind: "Variable",
          name: {
            kind: "Name",
            value: "to"
          }
        },
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      },
      {
        kind: "VariableDefinition",
        variable: {
          kind: "Variable",
          name: {
            kind: "Name",
            value: "all_world"
          }
        },
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Boolean"
          }
        }
      }
    ],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "suggestAddress"
        },
        arguments: [
          {
            kind: "Argument",
            name: {
              kind: "Name",
              value: "query"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "term"
              }
            }
          },
          {
            kind: "Argument",
            name: {
              kind: "Name",
              value: "fromBound"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "from"
              }
            }
          },
          {
            kind: "Argument",
            name: {
              kind: "Name",
              value: "toBound"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "to"
              }
            }
          },
          {
            kind: "Argument",
            name: {
              kind: "Name",
              value: "allWorld"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "all_world"
              }
            }
          }
        ],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "AddressFields"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "AddressFields"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "AddressType"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "area"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "areaFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "areaKladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "areaType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "areaTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "areaWithType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "block"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "blockType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "blockTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "capitalMarker"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "city"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityArea"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityDistrict"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityDistrictFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityDistrictKladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityDistrictType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityDistrictTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityDistrictWithType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityKladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "cityWithType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "country"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "countryIsoCode"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "entrance"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "federalDistrict"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "fiasCode"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "fiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "fiasLevel"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "flat"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "flatArea"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "flatCadnum"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "flatFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "flatType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "flatTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "floor"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "geoLat"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "geoLon"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "geonameId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "historyValues"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "house"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "houseCadnum"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "houseFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "houseKladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "houseType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "houseTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "kladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "postalBox"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "postalCode"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "region"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "regionFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "regionIsoCode"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "regionKladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "regionType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "regionTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "regionWithType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "settlement"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "settlementFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "settlementKladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "settlementType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "settlementTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "settlementWithType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "street"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "streetFiasId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "streetKladrId"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "streetType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "streetTypeFull"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "streetWithType"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "timezone"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "unparsedParts"
          }
        },
        {
          kind: "Field",
          name: {
            kind: "Name",
            value: "value"
          }
        }
      ]
    }
  }]
}, Se = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "specialProjects"
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "specialProjects"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "id"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "slug"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "name"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "photo"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "projectUrl"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "description"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "hasFormScheme"
              }
            }
          ]
        }
      }]
    }
  }]
}, Ae = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "SaveUserData"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "user"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "UpdateUserInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "updateUser"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "user"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "user"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
}, _e = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "UpdateUserMetrica"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "refererUrl"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "ymClientId"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "updateYandexMetrica"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "refererUrl"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "refererUrl"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "ymClientId"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "ymClientId"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "success"
            }
          }]
        }
      }]
    }
  }]
}, be = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "GetUserGeolocation"
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "userGeoLocationLog"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "country"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "countryIsoCode"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "region"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "regionFiasId"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "city"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "cityFiasId"
              }
            }
          ]
        }
      }]
    }
  }]
}, De = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "GetUser"
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "me"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "id"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "uuid"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "username"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "nickname"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "avatar"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "avatarUrl"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "vkAvatar"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "vkAccount"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "firstName"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "lastName"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "middleName"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "email"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "phone"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "promotionalMailings"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "birthDate"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "agreement"
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "address"
              },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "area"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "areaFiasId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "areaKladrId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "areaType"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "areaTypeFull"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "areaWithType"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "block"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "blockType"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "blockTypeFull"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "capitalMarker"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "city"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "cityArea"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "cityDistrict"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "cityDistrictFiasId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "cityDistrictKladrId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "cityDistrictType"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "cityDistrictTypeFull"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "cityDistrictWithType"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "cityFiasId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "cityKladrId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "cityType"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "cityTypeFull"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "cityWithType"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "country"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "countryIsoCode"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "entrance"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "federalDistrict"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "fiasCode"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "fiasId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "fiasLevel"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "flat"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "flatArea"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "flatCadnum"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "flatFiasId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "flatType"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "flatTypeFull"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "floor"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "geoLat"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "geoLon"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "geonameId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "historyValues"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "house"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "houseCadnum"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "houseFiasId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "houseKladrId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "houseType"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "houseTypeFull"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "kladrId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "postalBox"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "postalCode"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "region"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "regionFiasId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "regionIsoCode"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "regionKladrId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "regionType"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "regionTypeFull"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "regionWithType"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "settlement"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "settlementFiasId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "settlementKladrId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "settlementType"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "settlementTypeFull"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "settlementWithType"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "street"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "streetFiasId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "streetKladrId"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "streetType"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "streetTypeFull"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "streetWithType"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "timezone"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "unparsedParts"
                    }
                  },
                  {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "value"
                    }
                  }
                ]
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "speakerRequests"
              },
              selectionSet: {
                kind: "SelectionSet",
                selections: [{
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "status"
                  }
                }]
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "speakers"
              },
              selectionSet: {
                kind: "SelectionSet",
                selections: [{
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "id"
                  }
                }, {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "statusRequest"
                  }
                }]
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "lead"
              },
              selectionSet: {
                kind: "SelectionSet",
                selections: [{
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "projectLink"
                  }
                }]
              }
            },
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "projects"
              },
              selectionSet: {
                kind: "SelectionSet",
                selections: [{
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "slug"
                  }
                }]
              }
            }
          ]
        }
      }]
    }
  }]
}, Ee = [
  b.A_0,
  b.A_1,
  b.A_2,
  b.A_3
], Ue = {
  url: me,
  realm: ue,
  clientId: ke
}, Ce = 30, Le = 1e3, d = new ne(Ue), j = () => {
  if (typeof window > "u") return !1;
  try {
    const e = sessionStorage.getItem(g.authorizeInFlight);
    if (!e) return !1;
    const n = Number(e);
    return !Number.isFinite(n) || Date.now() - n > 15e3 ? (sessionStorage.removeItem(g.authorizeInFlight), !1) : !0;
  } catch {
    return !1;
  }
}, we = () => {
  try {
    sessionStorage.setItem(g.authorizeInFlight, String(Date.now()));
  } catch {
  }
}, A = () => {
  try {
    sessionStorage.removeItem(g.authorizeInFlight);
  } catch {
  }
}, K = !1, $e = () => {
  if (K) return;
  K = !0;
  const e = d.login;
  d.login = ((n) => {
    if (j()) return Promise.resolve();
    we();
    try {
      return e(n);
    } catch (i) {
      throw A(), i;
    }
  });
}, P = () => {
  const e = d.tokenParsed?.exp, n = e ? /* @__PURE__ */ new Date(e * Le) : void 0;
  p.set("access_token", d.token || "", n ? { expires: n } : {});
}, Re = /[^A-Za-z0-9\-._~:/?#[\]@!$&'()*+,;=%]/, Oe = () => {
  const { href: e, origin: n, pathname: i } = window.location;
  let a;
  try {
    const r = new URL(e);
    r.search = new URLSearchParams(r.search).toString(), a = Re.test(r.href) ? n + i : r.href;
  } catch {
    a = n + i;
  }
  a !== e && window.history.replaceState(window.history.state, "", a);
}, Ve = [
  "code",
  "state",
  "session_state",
  "error",
  "error_description",
  "iss"
], Me = (e) => {
  try {
    const n = new URL(e);
    for (const i of Ve) n.searchParams.delete(i);
    return n.href;
  } catch {
    return e;
  }
}, Ke = async (e) => {
  if (typeof window > "u") return !1;
  Oe(), $e(), d.onReady = () => {
    e.events.emit("keycloakReady");
  }, d.onAuthError = () => {
    A(), p.remove("access_token");
  }, d.onAuthRefreshSuccess = () => {
    d.token && P();
  }, d.onAuthLogout = () => {
    p.remove("access_token");
  }, d.onTokenExpired = () => {
    p.remove("access_token");
  };
  try {
    const n = e.config?._usage === "external", i = await d.init({
      checkLoginIframe: n,
      onLoad: "check-sso",
      responseMode: "query"
    });
    return i && d.token ? P() : p.remove("access_token"), i;
  } catch {
    return p.remove("access_token"), d.authenticated ?? !1;
  }
}, C = async () => {
  if (typeof window > "u" || !d || !(d.authenticated ?? !1)) return null;
  try {
    await d.updateToken(Ce);
  } catch {
    return null;
  }
  return d.token ?? null;
}, Pe = async (e = -1) => await d.updateToken(e), Ge = () => async (e) => {
  const n = await C();
  if (!n) return e;
  const i = new Headers(e.headers);
  return i.set("Authorization", `Bearer ${n}`), {
    ...e,
    headers: i
  };
}, Y = (e) => new ee(e ?? se, {
  credentials: "include",
  mode: "cors",
  requestMiddleware: Ge()
}), We = Y();
function O(e, n, i) {
  return We.request(e, n, i);
}
var ze = {
  "\n	mutation CheckEmailCode($email: String!, $code: String!) {\n		emailCodeCheck(email: $email, code: $code) {\n    	success\n  	}\n	}\n": ye,
  "\n	mutation Login($username: String!, $token: String!) {\n		tokenAuth(username: $username, password: $token) {\n			payload\n			token\n		}\n	}	\n": Ne,
  "\n    mutation Logout {\n        deleteTokenCookie {\n            deleted\n        }\n        deleteRefreshTokenCookie {\n            deleted\n        }\n    }\n": Fe,
  "\n  mutation Registration($user: UserInput) {\n    registerUser(input: $user) {\n      user {\n        id\n      }\n    }\n  }\n": he,
  "\n	mutation SendAuthEmail($username: String!, $refererUrl: String, $ymClientId: String) {\n		sendEmailCode(email: $username, refererUrl: $refererUrl, ymClientId: $ymClientId) {\n			success\n			userExists\n		}\n	}\n": ge,
  "\n	mutation SmsAuthWithToken(\n		$phone: String!\n		$token: String!\n		$uuid: UUID\n	) {\n  	createSmsAuthorizeWithToken(phone: $phone, token: $token, uuid: $uuid) {\n    	userExists\n  	}\n	}	\n": fe,
  "\n  mutation TokenAuthVk($code: String!, $codeVerifier: String!, $deviceId: String!) {\n    tokenAuthVkId(code: $code, codeVerifier: $codeVerifier, deviceId: $deviceId) {\n      payload\n      refreshExpiresIn\n      token\n      refreshToken\n    }\n  }\n": Te,
  "\n	fragment AddressFields on AddressType {\n		area\n		areaFiasId\n		areaKladrId\n		areaType\n		areaTypeFull\n		areaWithType\n		block\n		blockType\n		blockTypeFull\n		capitalMarker\n		city\n		cityArea\n		cityDistrict\n		cityDistrictFiasId\n		cityDistrictKladrId\n		cityDistrictType\n		cityDistrictTypeFull\n		cityDistrictWithType\n		cityFiasId\n		cityKladrId\n		cityType\n		cityTypeFull\n		cityWithType\n		country\n		countryIsoCode\n		entrance\n		federalDistrict\n		fiasCode\n		fiasId\n		fiasLevel\n		flat\n		flatArea\n		flatCadnum\n		flatFiasId\n		flatType\n		flatTypeFull\n		floor\n		geoLat\n		geoLon\n		geonameId\n		historyValues\n		house\n		houseCadnum\n		houseFiasId\n		houseKladrId\n		houseType\n		houseTypeFull\n		kladrId\n		postalBox\n		postalCode\n		region\n		regionFiasId\n		regionIsoCode\n		regionKladrId\n		regionType\n		regionTypeFull\n		regionWithType\n		settlement\n		settlementFiasId\n		settlementKladrId\n		settlementType\n		settlementTypeFull\n		settlementWithType\n		street\n		streetFiasId\n		streetKladrId\n		streetType\n		streetTypeFull\n		streetWithType\n		timezone\n		unparsedParts\n		value\n	}\n": pe,
  "\n  query GetAddress($term: String, $from: String, $to: String, $all_world: Boolean) {\n    suggestAddress(query: $term, fromBound: $from, toBound: $to, allWorld: $all_world) {\n      ...AddressFields\n    }\n  }\n": Ie,
  "\n  query specialProjects {\n    specialProjects {\n      id\n      slug\n      name\n      photo\n      projectUrl\n      description\n      hasFormScheme\n    }\n  }\n": Se,
  "\n	mutation SaveUserData($user: UpdateUserInput!) {\n		updateUser(input: $user) {\n			user {\n				id\n			}\n		}\n	}\n": Ae,
  "\n  mutation UpdateUserMetrica($refererUrl: String, $ymClientId: String) {\n    updateYandexMetrica(refererUrl: $refererUrl, ymClientId: $ymClientId) {\n      success\n    }\n  }\n": _e,
  "\n  query GetUserGeolocation {\n    userGeoLocationLog {\n      country\n      countryIsoCode\n      region\n      regionFiasId\n      city\n      cityFiasId\n    }\n  }": be,
  "\n  query GetUser {\n    me {\n      id\n      uuid\n      username\n      nickname\n      avatar\n      avatarUrl\n      vkAvatar\n      vkAccount\n      firstName\n      lastName\n      middleName\n      email\n      phone\n      promotionalMailings\n      birthDate\n      agreement\n      address {\n        area\n        areaFiasId\n        areaKladrId\n        areaType\n        areaTypeFull\n        areaWithType\n        block\n        blockType\n        blockTypeFull\n        capitalMarker\n        city\n        cityArea\n        cityDistrict\n        cityDistrictFiasId\n        cityDistrictKladrId\n        cityDistrictType\n        cityDistrictTypeFull\n        cityDistrictWithType\n        cityFiasId\n        cityKladrId\n        cityType\n        cityTypeFull\n        cityWithType\n        country\n        countryIsoCode\n        entrance\n        federalDistrict\n        fiasCode\n        fiasId\n        fiasLevel\n        flat\n        flatArea\n        flatCadnum\n        flatFiasId\n        flatType\n        flatTypeFull\n        floor\n        geoLat\n        geoLon\n        geonameId\n        historyValues\n        house\n        houseCadnum\n        houseFiasId\n        houseKladrId\n        houseType\n        houseTypeFull\n        kladrId\n        postalBox\n        postalCode\n        region\n        regionFiasId\n        regionIsoCode\n        regionKladrId\n        regionType\n        regionTypeFull\n        regionWithType\n        settlement\n        settlementFiasId\n        settlementKladrId\n        settlementType\n        settlementTypeFull\n        settlementWithType\n        street\n        streetFiasId\n        streetKladrId\n        streetType\n        streetTypeFull\n        streetWithType\n        timezone\n        unparsedParts\n        value\n      }\n      speakerRequests {\n        status\n      }\n      speakers {\n        id\n        statusRequest\n      }\n      lead {\n        projectLink\n      }\n      projects {\n        slug\n      }\n    }\n  }\n": De
};
function v(e) {
  return ze[e] ?? {};
}
var yi = v(`
	mutation CheckEmailCode($email: String!, $code: String!) {
		emailCodeCheck(email: $email, code: $code) {
    	success
  	}
	}
`), Ni = v(`
	mutation Login($username: String!, $token: String!) {
		tokenAuth(username: $username, password: $token) {
			payload
			token
		}
	}	
`), Fi = v(`
    mutation Logout {
        deleteTokenCookie {
            deleted
        }
        deleteRefreshTokenCookie {
            deleted
        }
    }
`), hi = v(`
  mutation Registration($user: UserInput) {
    registerUser(input: $user) {
      user {
        id
      }
    }
  }
`), gi = v(`
	mutation SendAuthEmail($username: String!, $refererUrl: String, $ymClientId: String) {
		sendEmailCode(email: $username, refererUrl: $refererUrl, ymClientId: $ymClientId) {
			success
			userExists
		}
	}
`), fi = v(`
	mutation SmsAuthWithToken(
		$phone: String!
		$token: String!
		$uuid: UUID
	) {
  	createSmsAuthorizeWithToken(phone: $phone, token: $token, uuid: $uuid) {
    	userExists
  	}
	}	
`), Ti = v(`
  mutation TokenAuthVk($code: String!, $codeVerifier: String!, $deviceId: String!) {
    tokenAuthVkId(code: $code, codeVerifier: $codeVerifier, deviceId: $deviceId) {
      payload
      refreshExpiresIn
      token
      refreshToken
    }
  }
`), Ii = v(`
  query GetAddress($term: String, $from: String, $to: String, $all_world: Boolean) {
    suggestAddress(query: $term, fromBound: $from, toBound: $to, allWorld: $all_world) {
      ...AddressFields
    }
  }
`), Si = v(`
  query specialProjects {
    specialProjects {
      id
      slug
      name
      photo
      projectUrl
      description
      hasFormScheme
    }
  }
`), xe = v(`
	mutation SaveUserData($user: UpdateUserInput!) {
		updateUser(input: $user) {
			user {
				id
			}
		}
	}
`), Be = v(`
  mutation UpdateUserMetrica($refererUrl: String, $ymClientId: String) {
    updateYandexMetrica(refererUrl: $refererUrl, ymClientId: $ymClientId) {
      success
    }
  }
`), Ai = v(`
  query GetUserGeolocation {
    userGeoLocationLog {
      country
      countryIsoCode
      region
      regionFiasId
      city
      cityFiasId
    }
  }`), je = v(`
  query GetUser {
    me {
      id
      uuid
      username
      nickname
      avatar
      avatarUrl
      vkAvatar
      vkAccount
      firstName
      lastName
      middleName
      email
      phone
      promotionalMailings
      birthDate
      agreement
      address {
        area
        areaFiasId
        areaKladrId
        areaType
        areaTypeFull
        areaWithType
        block
        blockType
        blockTypeFull
        capitalMarker
        city
        cityArea
        cityDistrict
        cityDistrictFiasId
        cityDistrictKladrId
        cityDistrictType
        cityDistrictTypeFull
        cityDistrictWithType
        cityFiasId
        cityKladrId
        cityType
        cityTypeFull
        cityWithType
        country
        countryIsoCode
        entrance
        federalDistrict
        fiasCode
        fiasId
        fiasLevel
        flat
        flatArea
        flatCadnum
        flatFiasId
        flatType
        flatTypeFull
        floor
        geoLat
        geoLon
        geonameId
        historyValues
        house
        houseCadnum
        houseFiasId
        houseKladrId
        houseType
        houseTypeFull
        kladrId
        postalBox
        postalCode
        region
        regionFiasId
        regionIsoCode
        regionKladrId
        regionType
        regionTypeFull
        regionWithType
        settlement
        settlementFiasId
        settlementKladrId
        settlementType
        settlementTypeFull
        settlementWithType
        street
        streetFiasId
        streetKladrId
        streetType
        streetTypeFull
        streetWithType
        timezone
        unparsedParts
        value
      }
      speakerRequests {
        status
      }
      speakers {
        id
        statusRequest
      }
      lead {
        projectLink
      }
      projects {
        slug
      }
    }
  }
`), D = {
  user: ["me"],
  updateUser: ["updateUser"],
  emailCode: ["sendEmailCode"],
  otpSend: ["otp_send"],
  phoneAuthGetCode: ["phoneAuth", "getCode"],
  tokenAuthVkId: ["tokenAuthVkId"],
  checkEmail: ["checkEmail"],
  siteActivate: ["siteActivate"],
  login: ["login"],
  updateYandexMetrica: ["updateYandexMetrica"],
  userGeolocation: ["userGeolocation"],
  specialProjects: ["specialProjects"],
  address: (e) => ["address", e]
}, _i = R.create({
  prefixUrl: `${oe}/`,
  credentials: "include",
  hooks: { beforeRequest: [async (e) => {
    const n = await C();
    n && e.headers.set("Authorization", `Bearer ${n}`);
  }] }
}), Ye = 60 * 1e3;
function G() {
  return new ie({ defaultOptions: { queries: {
    staleTime: Ye,
    refetchOnWindowFocus: !1,
    retry: !1
  } } });
}
var L;
function q() {
  return ae ? G() : (L || (L = G()), L);
}
var qe = "@frontend/roz-sdk-core", Xe = "0.0.3", He = { "@frontend:registry": "https://gitlab.roznanie.ru/api/v4/projects/40/packages/npm/" }, Qe = "Headless logic core for Roz SDK (auth, user, events, analytics, utils, config). React-free.", Ze = "module", Je = "./dist/index.js", en = "./dist/index.d.ts", nn = {
  ".": {
    types: "./dist/index.d.ts",
    import: "./dist/index.js"
  },
  "./testing": {
    types: "./dist/testing.d.ts",
    import: "./dist/testing.js"
  }
}, an = ["dist"];
var tn = "git@gitlab.roznanie.ru:frontend/roz-sdk.git", dn = {
  dev: "vite build --watch",
  build: "vite build",
  typecheck: "tsc --noEmit --project tsconfig.json",
  test: "vitest run",
  "test:watch": "vitest",
  "check:no-react": "bash scripts/check-no-react.sh"
}, rn = {
  "@tanstack/react-query": "catalog:",
  dayjs: "catalog:",
  deepmerge: "catalog:",
  "graphql-request": "catalog:",
  "js-cookie": "catalog:",
  "keycloak-js": "^26.2.2",
  ky: "^1.8.1",
  zustand: "catalog:"
}, ln = {
  "@graphql-typed-document-node/core": "catalog:",
  "@types/js-cookie": "catalog:",
  "@types/node": "catalog:",
  "happy-dom": "^19.0.2",
  typescript: "catalog:",
  vite: "catalog:",
  "unplugin-dts": "catalog:",
  vitest: "catalog:"
}, on = {
  name: qe,
  version: Xe,
  publishConfig: He,
  description: Qe,
  type: Ze,
  module: Je,
  types: en,
  exports: nn,
  files: an,
  sideEffects: !1,
  repository: tn,
  scripts: dn,
  dependencies: rn,
  devDependencies: ln
}, E = "roz-sdk-debug", W = "debug", X = "*", sn = () => globalThis.window !== void 0;
function mn() {
  const e = globalThis.window.location?.search ?? "", n = new URLSearchParams(e);
  if (!n.has(W)) return;
  const i = n.get(W);
  if (i === "0") {
    localStorage.removeItem(E);
    return;
  }
  if (i === null || i === "" || i === "1") {
    localStorage.setItem(E, X);
    return;
  }
  localStorage.setItem(E, i);
}
function un(e) {
  const n = localStorage.getItem(E);
  return n ? n === X ? !0 : n.split(",").map((i) => i.trim()).includes(e) : !1;
}
function kn(e, ...n) {
  if (sn()) {
    try {
      if (mn(), !un(e)) return;
    } catch {
      return;
    }
    console.log(`[${e}]`, ...n);
  }
}
var cn = {
  analytics: { enabled: !0 },
  theme: "dark",
  _usage: "external",
  debug: !0
}, U = "data-ntpc", H = "GTM-init", bi = "GTM", Di = `script[${U}="${H}"]`, Ei = `script[${U}="GTM"]`, vn = (e) => {
  if (typeof window > "u") return null;
  const n = window, i = n[e];
  if (i) return i;
  const a = [];
  return n[e] = a, a;
}, pn = (e, n, i) => {
  const a = (/* @__PURE__ */ new Date()).toLocaleString("ru-RU", { timeZone: "Europe/Moscow" }), r = vn(i ?? "dataLayer");
  r && r.push({
    event: de,
    payload: {
      event: e,
      params: {
        ...n,
        date: a
      }
    }
  });
}, yn = /Tablet|iPad|PlayBook|Silk/i, Nn = /Mobile|iPhone|iPod|Android|BlackBerry|IEMobile|Opera Mini/i, Fn = /iP(hone|od|ad)/i, hn = /Safari/i, gn = /CriOS|FxiOS|OPiOS|EdgiOS/i, fn = () => {
  let e = "unknown";
  const n = navigator.userAgent;
  if (n) {
    const i = yn.test(n), a = Nn.test(n);
    switch (!0) {
      case i:
        e = "tablet";
        break;
      case a:
        e = "phone";
        break;
      default:
        e = "desktop";
    }
  }
  return e;
}, Ui = () => {
  const e = typeof navigator > "u" ? "" : navigator.userAgent, n = Fn.test(e), i = hn.test(e) && !gn.test(e);
  return n && i;
}, Tn = (e) => e.split("?"), z = (e) => e.includes(globalThis.window.location.hostname) ? e : globalThis.window.location.origin + e, In = (e = 15e3, n = 100) => new Promise((i, a) => {
  if (globalThis.window === void 0 || document === void 0) return a("No window/document available");
  if (!!globalThis.window.ym) return i();
  const s = setInterval(() => {
    globalThis.window.ym && (clearInterval(s), clearTimeout(m), i());
  }, n), m = setTimeout(() => {
    clearInterval(s), a(`YM not found within ${e}ms`);
  }, e);
}), w = () => {
};
function Sn(e) {
  const n = () => e.isBrowser && typeof document < "u", i = (s, m, u) => {
    if (!e.isBrowser) return;
    const h = u ?? 84772729, y = () => globalThis.window.ym?.(h, "reachGoal", s, m);
    globalThis.window?.ym ? y() : In().then(() => y()).catch(() => {
    });
  };
  return {
    init: w,
    updateConfig: w,
    destroy: w,
    sendYmAnalyticsWithDefaultParams: async ({ params: s, blockName: m, additionalCounterId: u, additionalCounterEvent: h, ymEvent: y, url: o }) => {
      if (!n()) return;
      const F = o ?? globalThis.window.location.href, [t] = Tn(F), k = e.auth.isUserAuthorized(), S = (await e.user.getUser())?.me, l = p.get("_ym_uid") ?? "unknown", T = { events: { [m]: {
        title: document.title,
        url: z(t),
        url_params: z(F),
        block_name: m,
        userAuth: k ? "auth" : "not auth",
        uid: k ? S?.uuid || "unknown" : "na",
        id: k ? S?.id || "unknown" : "na",
        cid: l,
        device_type: fn(),
        ...s
      } } };
      i(y, T), u && i(h || y, T, u);
    },
    trackYmAnalytics: i,
    trackGTMAnalytics: async (s, m = {}) => {
      if (!e.isBrowser) return;
      const u = (await e.user.getUser())?.me;
      pn(s, {
        ...m,
        user: {
          ...u,
          user_id: u?.id
        }
      });
    }
  };
}
var An = {
  mainAuth: "phone",
  isRegistering: !1,
  embedAuthSelector: null,
  registrationFrom: ""
}, _n = B((e) => ({
  ...An,
  updateAuthProps: (n) => e((i) => ({
    ...i,
    ...n
  })),
  setIsRegistering: (n) => e({ isRegistering: n }),
  setEmbedAuthSelector: (n) => e({ embedAuthSelector: n }),
  setMainAuth: (n) => e({ mainAuth: n }),
  setRegistrationFrom: (n) => e({ registrationFrom: n })
})), I = {
  UID: "uid",
  TARGET_AG: "target_ag"
}, Ci = { TARGET_AG: "LK_LECTOR" }, Li = {
  REGISTER: "register",
  LOGIN: "login"
}, Q = (e) => typeof e == "object" && e !== null && "me" in e, bn = (e) => {
  const n = _n.getState(), i = q();
  let a = !1, r = !1;
  const s = 30, m = async () => {
    try {
      const l = (await e.user.refetchUser())?.me, T = p.get("_ym_uid") || "unknown", _ = new URL(window.location.href);
      _.search = "", await O(Be, {
        ymClientId: T,
        refererUrl: _.toString()
      }), e.analytics.trackYmAnalytics(I.UID, { personal_acc: { [`block_${I.UID}`]: {
        block_name: `block_${I.UID}`,
        userAuth: l ? "auth" : "not auth",
        uid: l ? l?.uuid : "na",
        id: l ? l?.id : "na"
      } } }), e.events.emit("login");
    } catch (l) {
      console.error(l);
    }
  }, u = () => {
    i.clear(), e.events.emit("logout");
  }, h = () => {
    a || (a = !0, d.onAuthSuccess = () => {
      A(), m();
    }, d.onAuthLogout = () => {
      A(), u();
    }, d.onTokenExpired = async () => {
      try {
        await d.updateToken(s);
      } catch {
        await d.logout();
      }
    });
  }, y = async (l) => {
    if (!e.isBrowser || r || j()) return;
    r = !0;
    const T = Me(l ?? globalThis.window.location.href);
    try {
      await d.login({ redirectUri: T });
    } catch (_) {
      throw r = !1, _;
    }
  }, o = async () => {
    if (e.isBrowser)
      try {
        sessionStorage.setItem(g.postLogout, M.hasCallback), await d.logout({ redirectUri: globalThis.window.location.href });
      } catch (l) {
        console.error(l);
      }
  }, F = () => (() => {
    const l = i.getQueryData(D.user);
    return !!d.authenticated || !!(Q(l) && l.me);
  })(), t = (l) => {
    l && (n.updateAuthProps(l), e.updateConfig({ authProps: {
      ...e.config.authProps,
      ...l
    } }));
  }, k = () => {
    sessionStorage.getItem(g.postLogout) === M.hasCallback && (u(), sessionStorage.removeItem(g.postLogout));
  };
  return {
    init: async () => {
      t(e.config.authProps), h(), k();
      try {
        await Ke(e);
      } finally {
        A();
      }
    },
    updateAuthProps: t,
    isUserAuthorized: F,
    login: y,
    logout: o,
    getAccessToken: C,
    refreshToken: Pe
  };
}, x = () => {
};
function Dn(e) {
  const n = q(), i = async () => e.auth.isUserAuthorized() ? await O(je) : null;
  let a = null;
  const r = () => {
    const t = i().then((k) => ({
      data: k,
      isFailed: !1
    })).catch(() => ({
      data: null,
      isFailed: !0
    })).finally(() => {
      a === t && (a = null);
    });
    return a = t, t;
  }, s = () => a ?? r(), m = async (t) => {
    const { data: k, isFailed: S } = await t;
    if (S) {
      const l = n.getQueryData(D.user);
      return e.events.emit("loadUser", l?.me), l ?? null;
    }
    return n.setQueryData(D.user, k), e.events.emit("loadUser", k?.me), k;
  }, u = async () => {
    if (!e.auth.isUserAuthorized())
      return e.events.emit("loadUser", void 0), null;
    const t = n.getQueryData(D.user);
    return Q(t) ? (e.events.emit("loadUser", t?.me), t) : await m(s());
  };
  return {
    init: async () => {
      const t = (await u())?.me;
      e.analytics.trackYmAnalytics(I.UID, { personal_acc: { [`block_${I.UID}`]: {
        block_name: `block_${I.UID}`,
        userAuth: t ? "auth" : "not auth",
        uid: t ? t?.uuid : "na",
        id: t ? t?.id : "na"
      } } });
    },
    updateConfig: x,
    destroy: x,
    fetchUser: i,
    refetchUser: async () => {
      try {
        return await m(r());
      } catch (t) {
        console.error(t);
      }
    },
    getUser: u,
    updateUser: async (t) => {
      try {
        await O(xe, t);
      } catch (k) {
        console.error(k);
      }
    },
    checkSpeakerPermissions: (t) => {
      const k = t?.speakers?.statusRequest;
      return k ? Ee.includes(k) : !1;
    }
  };
}
var En = (e) => Object.fromEntries(Object.entries(e).filter(([, n]) => n !== void 0)), $ = () => {
};
function Un(e) {
  return {
    init: $,
    updateConfig: $,
    destroy: $,
    uploadFileToS3: async (i, a) => {
      try {
        const { folder: r, customFilename: s, privateBucket: m } = a || {}, { url: u } = await R.get(`${le}/api/s3_signed_url`, { searchParams: En({
          filename: i.name,
          folder: r,
          customFilename: s,
          privateBucket: m
        }) }).json();
        return await R.put(u, {
          body: i,
          headers: { "Content-Type": i.type }
        }), u.split("?")[0];
      } catch (r) {
        throw console.error(r), r;
      }
    },
    getAccessKeycloakToken: C
  };
}
var Cn = (e) => ({
  auth: bn(e),
  user: Dn(e),
  analytics: Sn(e),
  utils: Un(e)
}), Z = class N {
  constructor(n) {
    c(this, "configListeners", []), c(this, "_readyPromise", void 0), c(this, "_readyResolver", void 0), c(this, "_readyRejecter", void 0), c(this, "config", void 0), c(this, "version", on.version), c(this, "auth", void 0), c(this, "user", void 0), c(this, "analytics", void 0), c(this, "utils", void 0), c(this, "events", void 0), c(this, "updateConfig", void 0), c(this, "subscribeToConfigUpdates", void 0), c(this, "ready", void 0), this.config = V(cn, n), this.updateConfig = this.updateConfigImpl.bind(this), this.subscribeToConfigUpdates = this.subscribeToConfigUpdatesImpl.bind(this), this.ready = this.readyImpl.bind(this), this._readyPromise = new Promise((i, a) => {
      this._readyResolver = i, this._readyRejecter = a;
    });
  }
  attachModules() {
    const n = Cn(this);
    this.analytics = n.analytics, this.user = n.user, this.auth = n.auth, this.utils = n.utils, this.events = J.getInstance();
  }
  async runModuleInit() {
    const n = [
      this.analytics,
      this.auth,
      this.utils,
      this.user
    ];
    for (const i of n) await i?.init();
    this._readyResolver();
  }
  static create(n) {
    if (N.instance)
      return console.warn("[SDK] Already initialized. Use SDK.getInstance() to access it."), N.instance;
    const i = new N(n);
    return N.instance = i, i.attachModules(), i.runModuleInit().then(() => i.events.emit("sdkReady")).catch((a) => {
      console.error("[SDK] Ошибка инициализации", a), i._readyRejecter(a);
    }), i;
  }
  static async init(n) {
    const i = N.create(n);
    return await i.ready(), i;
  }
  static getInstance() {
    if (!N.instance) throw new Error("SDK not yet initialized. Call SDK.init(config) first.");
    return N.instance;
  }
  static log(n, ...i) {
    kn(n, ...i);
  }
  readyImpl() {
    return this._readyPromise;
  }
  updateConfigImpl(n) {
    this.config = V(this.config, n);
    for (const i of this.configListeners) i(this.config);
  }
  subscribeToConfigUpdatesImpl(n) {
    return this.configListeners.push(n), () => {
      this.configListeners = this.configListeners.filter((i) => i !== n);
    };
  }
  static reset() {
    N.instance = void 0;
  }
  get isBrowser() {
    return globalThis.window !== void 0;
  }
};
c(Z, "instance", void 0);
c(Z, "getGraphQLClient", (e) => Y(e));
var wi = ({ gtmId: e, gtmAuth: n, gtmPreview: i, gtmLayer: a, gtmScriptUrl: r, dataLayer: s, dataLayerName: m }) => ({
  getNoscript: () => {
    const o = document.createElement("iframe");
    o.src = `https://www.googletagmanager.com/ns.html?id=${e}${n}${i}&gtm_cookies_win=x`, o.height = "0", o.width = "0", o.style.display = "none", o.style.visibility = "hidden", o.id = "tag-manager";
    const F = document.createElement("noscript");
    return F.append(o), F;
  },
  getGTMScript: () => {
    const o = document.createElement("script");
    return o.src = `${r}?id=${e}${a}${n}${i}`, o.setAttribute(U, "GTM"), o;
  },
  getGTMInitScript: () => {
    const o = document.createElement("script");
    return o.setAttribute(U, H), o.innerHTML = `
            (function(w,l){
                w[l]=w[l]||[];
                w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
                ${s ? `w[l].push(${JSON.stringify(s)})` : ""}
            })(window,'${m}');
        `, o;
  }
}), Ln = {
  isAuthorized: !1,
  authType: "Телефон",
  agreement: !1
}, $i = B()((e) => ({
  ...Ln,
  setIsAuthorized: (n) => e({ isAuthorized: n }),
  setAuthType: (n) => e({ authType: n }),
  setAgreement: (n) => e({ agreement: n })
})), wn = /[^\d+]/g, $n = /(?!^)\+/g, Rn = /^(?:[\S]*)$/, On = 0, Vn = 30, Ri = (e) => e.replaceAll(wn, "").replaceAll($n, ""), Mn = (e) => ve.test(e), Oi = (e) => ce.test(e) && !Mn(e), Vi = (e) => Rn.test(e) || e.trim().length > On, Mi = (e) => {
  p.set("userLocation", JSON.stringify(e), { expires: te().add(Vn, "day").toDate() });
}, Ki = () => {
  const e = p.get("userLocation");
  return e ? JSON.parse(e) : null;
};
export {
  Ii as ADDRESS_QUERY,
  Ee as ALLOWED_SPEAKER_STATUSES,
  oe as API_HOST,
  di as AUTHORIZE_LOCK_TTL_MS,
  ti as COOKIE_POLICY_NAME,
  pi as ContentTypeContentEnum,
  yi as EMAIL_CODE_CHECK_MUTATION,
  ce as FIO_REGEX,
  je as GET_USER,
  Ai as GET_USER_GEOLOCATION,
  se as GRAPHQL_ENDPOINT,
  de as GTMEventName,
  Qn as GTM_DEVELOPMENT_ID,
  H as GTM_INIT_NTPC,
  Di as GTM_INIT_SELECTOR,
  U as GTM_NTPC_ATTR,
  Hn as GTM_PRODUCTION_ID,
  bi as GTM_SCRIPT_NTPC,
  Ei as GTM_SCRIPT_SELECTOR,
  Li as GtmEventsType,
  ai as IS_PRODUCTION,
  ke as KEYCLOAK_CLIENT_ID,
  ue as KEYCLOAK_REALM,
  me as KEYCLOAK_URL,
  Ni as LOGIN_MUTATION,
  Fi as LOGOUT_MUTATION,
  ui as MAIN_SITE_ROUTES,
  ii as OMIT_MAINTENANCE_KEY,
  D as QUERY_KEYS,
  hi as REGISTRATION_MUTATION,
  ei as ROZ_MAX_AUTH_BOT_URL,
  Jn as ROZ_TG_AUTH_BOT_URL,
  Z as SDK,
  J as SDKEventBus,
  Zn as SDK_GLOBAL_NAME,
  vi as SDK_IDS,
  g as SDK_SESSION_KEYS,
  gi as SEND_EMAIL_CODE_MUTATION,
  M as SESSION_CALLBACK,
  le as SITE_DOMAIN,
  ni as SMART_CAPTCHA_KEY,
  fi as SMS_AUTH_WITH_TOKEN_MUTATION,
  Si as SPECIAL_PROJECTS_QUERY,
  Ti as TOKEN_AUTH_VK_MUTATION,
  ve as UKR_LETTERS_REGEX,
  Be as UPDATE_USER_METRICA_MUTATION,
  xe as UPDATE_USER_MUTATION,
  qn as YANDEX_METRIKA_COUNTER_ID,
  I as YmEventsType,
  Ci as YmLectorEventsType,
  ci as absoluteUrlRegexp,
  _i as apiClient,
  A as clearAuthorizeLock,
  kn as debugLog,
  Xn as defaultDataLayerName,
  O as execute,
  Ri as formatPhone,
  C as getAccessKeycloakToken,
  Ki as getCookieUserLocation,
  fn as getDeviceType,
  q as getQueryClient,
  wi as getTags,
  We as gqlClient,
  Ke as initializeKeycloak,
  mi as invalidEmailFormatText,
  oi as invalidFIOText,
  j as isAuthorizeLocked,
  Ui as isStrictMobileSafari,
  d as keycloak,
  si as notOnlySpacesText,
  Pe as refreshKeycloakToken,
  li as requiredFromListText,
  ri as requiredText,
  Mi as saveUserLocation,
  we as setAuthorizeLock,
  Me as stripOidcCallbackParams,
  ki as telOrMailLinkRegexp,
  _n as useAuthStore,
  $i as useUserStore,
  Oi as validateFIO,
  Vi as validateSpaces,
  Mn as validateUkrainianLetters,
  $e as wrapKeycloakLogin
};

//# sourceMappingURL=index.js.map